import React from "react";
import { fieldValidation } from "../../amorg-common";
import { EditableText } from "./EditableText";

type TitleContainerProps = {
    title: string;
    updateTitle: (value: string) => void;
};

export function TitleContainer (props: TitleContainerProps)
{
    return (

        <EditableText
            ariaLabel='mødetitel'
            value={props.title}
            validator={(currentValue) =>
            {
                if (fieldValidation.activity.title(currentValue))
                    return { valid: true };
                return { valid: false, errorMessage: `Ugyldig titel. Skal udfyldes med maks. 100 (${currentValue.length}) tegn.` };
            }}
            onSave={async (value) =>
            {
                if (fieldValidation.activity.title(value))
                    props.updateTitle(value);
            }}
            styleMode='H2'
            placeholder="Indtast overskrift" />

    );
}